import { NgModule } from '@angular/core';
import { LibEditIconComponent } from './lib-edit-icon.component';

@NgModule({
  declarations: [LibEditIconComponent],
  imports: [],
  exports: [LibEditIconComponent],
})
export class LibEditIconModule {}
